import * as moment from "moment";

let dateOfBegining = "2015";

export default {
  namespaced: true,
  state: {
    name: "Edgar",
    mainTechnologies: ["vue", "js","typescript", "vitejs", "vitest", "html", "css", "sass", "tailwindcss", "bootstrap", "githubactions", "docker"],
    yearsOfExperience: moment().diff(moment(dateOfBegining), "years"),
    contactLinks: {
      gmail: "edgar@edgar-dias.eu",
      linkedin: "https://www.linkedin.com/in/edgar-s-dias/",
      github: "https://github.com/EDGI9",
    },
    personalDescription: {
      title: "Hi, I'm {name}. Nice to meet you.",
      text: "I'm a Front-End developer with {yearsOfExperience} years of experience. I've worked on several projects for international clients along the way and collaborated with talented people to create great products. I'm naturally curious, friendly and perpetually working on improving my skills a problem at a time.",
    },
    skillsDescription: {
      title: "How can I help?",
      text: "I'm experienced in modern Front-end technologies and tools such as HTML, CSS, CSS processors, Vue.js 2 and 3, Vite, Unit Testing with Vitest, containerization with Docker and other libraries and tools. With an eye for detail I concern myself with full development cycle ensuring quality product delivery with the help of Unit Tests, CI/CD pipelines and industry best practices.",
    },
  },
  getters: {
    NAME(state) {
      return state.name;
    },
    MAIN_TECHNOLOGIES(state) {
      return state.mainTechnologies;
    },
    YEARS_OF_EXPERIENCE(state) {
      return state.yearsOfExperience;
    },
    CONTACT_LINKS(state) {
      return state.contactLinks;
    },
    PERSONAL_DESCRIPTION(state) {
      return state.personalDescription;
    },
    SKILLS_DESCRIPTION(state) {
      return state.skillsDescription;
    },
  },
  mutations: {
    UPDATE_PERSONAL_DESCRIPTION(state) {
      state.personalDescription.title = state.personalDescription.title.replace(
        "{name}",
        state.name
      );

      state.personalDescription.text = state.personalDescription.text.replace(
        "{yearsOfExperience}",
        state.yearsOfExperience
      );
    },
  },
  actions: {
    SET_PERSONAL_DETAILS({ commit }) {
      commit("UPDATE_PERSONAL_DESCRIPTION");
    },
  },
};
